import baseRoutes from './components/baseRoutes'
import contentRoutes from './components/Content/routes'
import modelRoutes from './components/Model/routes'
import FlowRoutes from './components/Flow/routes'
import mobileRoutes from './components/Mobile/routes'
import parameterRoutes from './components/Parameter/routes'

let routes = []
routes = routes.concat(baseRoutes)
               .concat(contentRoutes)
               .concat(modelRoutes)
               .concat(FlowRoutes)
               .concat(mobileRoutes)
               .concat(parameterRoutes)

export default routes



// WEBPACK FOOTER //
// ./src/routes.js